import pl from './pl.json'
import en from './en.json'

export type Translations = Record<string, Record<string, string>>

export default {
	en,
	pl,
} as Translations
